import { render, staticRenderFns } from "./solicitedVConcluded.vue?vue&type=template&id=6036051b&scoped=true"
import script from "./solicitedVConcluded.vue?vue&type=script&lang=js"
export * from "./solicitedVConcluded.vue?vue&type=script&lang=js"
import style0 from "./solicitedVConcluded.vue?vue&type=style&index=0&id=6036051b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6036051b",
  null
  
)

export default component.exports